import Style from "./ProductsTableStyle";
import Spinner from "../../shared/Spinner/Spinner";
import TwoButtonsModal from "../../shared/Bootstrap/TwoButtonsModal";
import * as utils from "../../utils";
import api from "../../services/api";
import { useStateIfMounted } from "use-state-if-mounted";
import { FaTrashAlt } from "react-icons/fa";
import React, { useContext, useEffect, useState } from "react";
import AuthContext from "../../contexts/authContext";
import PageTitle from "../../components/PageTitle";


interface Product {
  id: number,
  name: string,
  email: string,
  displayName: string,
  price: number,
  oldCompany: string,
  companyId: number,
  category: string,
  categoryId: number,
  iconUrl: string,
  meshUrl: string,
}

export default function ProductsTable(props) {
  const { userData } = useContext(AuthContext);

  const [products, setProducts] = useStateIfMounted([] as Product[]);
  const [loading, setLoading] = useStateIfMounted(false);
  const [errorMessage, setErrorMessage] = useState("");


  const [deletingProduct, setDeletingProduct] = useState(false);
  const [productToDelete, setProductToDelete] = useState({} as any);

  useEffect(() => {
    LoadProducts();
  }, []);


  async function LoadProducts() {
    try {
      const result = await api.get("/products");
      const products = result.data.allProducts;
      setProducts(products);
      setLoading(false);
    }
    catch (error) {
      console.error("Erro pegando produtos: ", error);
      setErrorMessage("Erro carregando produtos!");
      setLoading(false);
    }
  }

  async function DeleteProduct() {
    setDeletingProduct(true);
    try {
      const result = await api.delete(`/products/${productToDelete.id}`);
      if (!result.data.success) {
        setErrorMessage(result.data.message || "Não foi possível deletar produto");
        console.error("Não foi possível deletar produto ", result.data);
      }
      else
        setErrorMessage("");

      await LoadProducts();
      setDeletingProduct(false);
      ClosePopupDeletingProduct();
    }
    catch (error: any) {
      setErrorMessage(error.response?.data?.message || "Erro deletando produto");
    }
    finally {
      await LoadProducts();
      setDeletingProduct(false);
      ClosePopupDeletingProduct();
    }
  }

  function ClosePopupDeletingProduct() {
    setProductToDelete({});
  }

  function GoToProduct(productId: number) {
    props.history.push(`/products/${productId}`);
  }



  return (
    <Style>
      <PageTitle title="Produtos" />
      <Spinner spinning={loading} />
      <TwoButtonsModal
        show={productToDelete.id != null}
        onHide={ClosePopupDeletingProduct}
        loading={deletingProduct}
        title="Deleção de produto!"
        body={`Você está tentando deletar o produto "${productToDelete.name}", essa ação é irreversível!`}
        secondaryText="Fechar"
        secondaryOnClick={ClosePopupDeletingProduct}
        secondaryDisabled={deletingProduct}
        primaryText="Deletar"
        primaryOnClick={DeleteProduct}
        primaryDisabled={deletingProduct}
      />

      {errorMessage && <p className="alert alert-error">Erro: {errorMessage}</p>}

      <section className="table-title">
        <h1>Produtos</h1>
        <button onClick={() => GoToProduct(0)}>Adicionar Produto</button>
      </section>


      <table className="table table-striped table-bordered table-hover main-table">
        <thead >
          <tr>
            <th>Nome do Produto</th>
            <th>Nome Exibição</th>
            <th>Preço</th>
            <th>Categoria</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          {products.length > 0 && products.map(product => {
            return (
              <tr key={product.id}>
                <td onClick={() => GoToProduct(product.id)} className="clickable">{product.name}</td>
                <td onClick={() => GoToProduct(product.id)} className="clickable">{product.displayName}</td>
                <td onClick={() => GoToProduct(product.id)} className="clickable">{utils.CentsToHuman(product.price)}</td>
                <td onClick={() => GoToProduct(product.id)} className="clickable">{product.category}</td>
                <td className="action">
                  <button
                    onClick={() => setProductToDelete(product)}
                    disabled={product.companyId !== userData.companyId}
                  ><FaTrashAlt className="icon" /></button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </Style>

  )
}